import styled from "styled-components";

export const OneLineContainer = styled.div`
  display: flex;
  align-items: flex-start ;
`